// src/pages/Dashboard/Admin/Coaching/components/CoachingTeacherSelectorCard.jsx

import React from "react";
import { FaSyncAlt, FaUserTie } from "react-icons/fa";

export default function CoachingTeacherSelectorCard({
  teachers,
  selectedTeacher,
  selectedTeacherId,
  loadingTeachers,
  loadingEvents,
  onSelectTeacher,
  onRefreshTeacher,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Enseignant
            </p>

            <h2 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
              <FaUserTie className="text-indigo-600 dark:text-indigo-300" />
              Sélection du coach
            </h2>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Choisissez un enseignant pour afficher ses événements et modifier
              ses heures de coaching.
            </p>
          </div>

          <div className="flex w-full flex-col gap-2 sm:flex-row lg:w-auto">
            <select
              value={selectedTeacherId}
              onChange={(event) => onSelectTeacher(event.target.value)}
              disabled={loadingTeachers}
              className="min-w-full rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 sm:min-w-[320px]"
            >
              <option value="">
                {loadingTeachers
                  ? "Chargement des enseignants..."
                  : "Sélectionnez un enseignant"}
              </option>

              {teachers.map((teacher) => (
                <option key={teacher.id} value={teacher.id}>
                  {teacher.nom} {teacher.prenom}
                </option>
              ))}
            </select>

            <button
              type="button"
              onClick={onRefreshTeacher}
              disabled={!selectedTeacherId || loadingEvents}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              <FaSyncAlt className={loadingEvents ? "animate-spin" : ""} />
              Actualiser
            </button>
          </div>
        </div>

        {selectedTeacher ? (
          <div className="mt-4 rounded-2xl border border-indigo-200 bg-indigo-50 px-4 py-3 text-sm text-indigo-800 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-200">
            Enseignant sélectionné :{" "}
            <span className="font-bold">
              {selectedTeacher.nom} {selectedTeacher.prenom}
            </span>
          </div>
        ) : null}
      </div>
    </section>
  );
}